/**
 * @generated SignedSource<<d540e949defd5beb29d8ec0a3971d74b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpSharedShipsFrom_item$data = {
  readonly locationBrowseUrl: {
    readonly path: string | null;
    readonly " $fragmentSpreads": FragmentRefs<"SeoLink_linkData">;
  };
  readonly address: {
    readonly itemAddress: string | null;
  } | null;
  readonly " $fragmentType": "PdpSharedShipsFrom_item";
};
export type PdpSharedShipsFrom_item$key = {
  readonly " $data"?: PdpSharedShipsFrom_item$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpSharedShipsFrom_item">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpSharedShipsFrom_item",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "LinkData",
      "kind": "LinkedField",
      "name": "locationBrowseUrl",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "path",
          "storageKey": null
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "SeoLink_linkData"
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Address",
      "kind": "LinkedField",
      "name": "address",
      "plural": false,
      "selections": [
        {
          "alias": "itemAddress",
          "args": [
            {
              "kind": "Literal",
              "name": "fullCountryName",
              "value": true
            }
          ],
          "kind": "ScalarField",
          "name": "displayCityStateCountry",
          "storageKey": "displayCityStateCountry(fullCountryName:true)"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Item",
  "abstractKey": null
};

(node as any).hash = "e31603b9755c44a09895d168e0340eab";

export default node;
